import './index.css'
import { fury, notifications } from '@netfleets/fms-sdk'
import { FuryBundleEvent } from '@netfleets/fms-types'
import { PREOPCHECK_APP_NAME, PREOPCHECK_TILE_NAME } from './fury-integration/config'

const customElements: fury.FuryCustomElementRegistration[] = [
  {
    customElementName: PREOPCHECK_APP_NAME,
    getCustomElementHandler: async () => import('./fury-integration/renderer-app'),
  },
  {
    customElementName: PREOPCHECK_TILE_NAME,
    getCustomElementHandler: async () => import('./fury-integration/renderer-tile'),
  },
]
export const getFuryToken = (): string | null => {
  return window.sessionStorage.getItem('fury.accessToken')
}

const authFetch = async (url: string, options?: RequestInit): Promise<Response> => {
  const headers = {
    Authorization: 'Bearer ' + getFuryToken(),
    'Content-Type': 'application/json',
  }
  const requestInit = {
    ...options,
    headers,
  }

  return fetch(url, requestInit)
}

const authFetchJson = async (url: string, options?: RequestInit): Promise<PocInfo> => {
  const res = await authFetch(url, options)
  if (!res.ok) {
    return Promise.reject(`Request failed: ${res.statusText}`)
  }
  return res.json()
}
type PocInfo = {
  show_in_menu: boolean
  show_tile: boolean
  enable_notifications: boolean
}
// Hook into fury if user can access location with POC licence
const furyIntegration = () => {
  const event: FuryBundleEvent = {
    bundleId: 'preopcheck',
    pages: [],
    lobbyTiles: [],
    bundleLoadedSubscriptions: {},
  }
  authFetchJson('/preopcheck/api/v1/fleet/poc-information')
    .then((pocInfo) => {
      // App
      if (pocInfo.show_in_menu) {
        event.pages?.push({
          route: 'preopcheck',
          elementName: PREOPCHECK_APP_NAME,
          translationKey: 'PREOPCHECK',
        })
      }

      // Dashboard Tile
      if (pocInfo.show_tile) {
        event.lobbyTiles?.push({
          elementName: PREOPCHECK_TILE_NAME,
          index: 310,
        })
      }

      // Enable notification subscription
      if (pocInfo.enable_notifications) {
        event.bundleLoadedSubscriptions!.notifications = () => {
          notifications.enableSubscribableNotifications(
            { type: 'preOpCheckFailedWithOutcomeCritical' },
            { type: 'preOpCheckFailedWithOutcomeHighlyCritical' },
            { type: 'preOpCheckWithOutcomeNeedsInspection' },
          )
        }
      }
      fury.register(customElements, event)
    })
    .catch(() => {
      // keep silent here, trigger fury register with empty events to avoid an infinite skeleton loading in case of
      // API error
      fury.register(customElements, event)
    })
}

furyIntegration()
